// Generated by content:build from libs/content/src. Do not edit.
import type { ContentSet } from '../../../model';

/** Production: published content only. */
export const CONTENT: ContentSet = {
  locale: 'en',
  articles: () => import('./articles').then(module => module.default),
  references: () => import('./references').then(module => module.default),
  jobs: () => import('./jobs').then(module => module.default),
  people: () => import('./people').then(module => module.default),
  events: () => import('./events').then(module => module.default),
};
